import React, { useState, useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'

import logoDark from '../assets/images/branding/logo-hap.svg'
import logoLight from '../assets/images/branding/logo-hap-bco.svg'
import { useSelector } from 'react-redux'
import contact from '../assets/images/contact.png'
import { footerSocial } from '../data/data'
import Offcanvas from 'react-bootstrap/Offcanvas';

export default function Navbar() {
    let [manu, setManu] = useState();
    let [show, setShow] = useState(false);
    const user = useSelector((state) => state.authentication?.user);
    const localuser = user ?? JSON.parse(user);
    let [scroll, setScroll] = useState(false)
    const [submenuOpen, setSubmenuOpen] = useState({
        servicios: false,
        arandaplus: false,
        mas: false,
    });

    let [open, setOpen] = useState(false);

    const dropdownRef = useRef(null);

    // const openSubmenu = (id) => {
    //     let submenu = document.getElementById(id);
    //     submenu.classList.toggle('open');
    // }

    const toggleSubmenu = (key) => {
        setSubmenuOpen(prev => ({
            ...prev,
            [key]: !prev[key]
        }));
    }

    useEffect(() => {
        window.scrollTo(0, 0)
        setManu(window.location.pathname)

        const handlerScroll = () => {
            if (window.scrollY > 50) {
                setScroll(true)
            } else { setScroll(false) }
        }

        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                // setSearch(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        window.addEventListener('scroll', handlerScroll)
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            window.removeEventListener('scroll', handlerScroll)
        };
    }, []);

    return (
        <>
            <header id="topnav" className={`defaultscroll sticky ${scroll ? 'nav-sticky' : ''}`}>
                <div className="container">
                    <Link className="logo" to="/">
                        <span className="logo-light-mode">
                            <img src={logoDark} className="l-dark mainlogo mainlogo-medium" alt="" />
                            <img src={logoLight} className="l-light mainlogo mainlogo-medium" alt="" />
                        </span>
                        <img src={logoLight} className="logo-dark-mode" alt="" />
                    </Link>

                    <div className="menu-extras">
                        <div className="menu-item">
                            <Link className={`navbar-toggle ${show ? 'open' : ''}`} id="isToggle" onClick={() => setShow(!show)}>
                                <div className="lines">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </div>
                            </Link>
                        </div>
                    </div>

                    <div id="navigation" className={show ? 'd-block' : 'd-none'}>
                        <ul className="navigation-menu nav-right nav-light">
                            <li className={manu === '/quienessomos' ? 'active' : ''}>
                                <Link to="/quienessomos" onClick={() => setManu(manu === '/hero-item' ? '' : '/hero-item')}>Quiénes somos</Link>
                            </li>

                            <li className={`has-submenu parent-menu-item ${['/servicios', '/paquetes', '/servicio', '/laboratorio', '/tecnologia'].includes(manu) ? 'active' : ''}`}>
                                <Link to="#" className="sub-menu-item" onClick={() => toggleSubmenu('servicios')}>Servicios</Link> <span className="menu-arrow"></span>
                                <ul id="submenu-servicios" className={`submenu ${submenuOpen.servicios ? 'open' : ''}`}>
                                    <li className={manu === '/servicios' ? 'active' : ''}><Link to="/servicios" className="sub-menu-item">Instalaciones y Servicios</Link></li>
                                    <li className={manu === '/tecnologia' ? 'active' : ''}><Link to="/tecnologia" className="sub-menu-item">Tecnología y Equipamiento</Link></li>
                                    <li className={manu === '/servicios' ? 'active' : ''}><Link to="/paquetes" className="sub-menu-item">Paquetes y Promociones</Link></li>
                                    <li className={manu === '/laboratorio' ? 'active' : ''}><Link to="/laboratorio" className="sub-menu-item">Laboratorio</Link></li>
                                </ul>
                            </li>

                            <li className={`menu-example ${['/directorio', '/directorio/dr/1'].includes(manu) ? 'active' : ''}`}><Link to="/directorio" className="sub-menu-item">Directorio Médico</Link></li>
                            <li className={manu === '/eventos' ? 'active' : ''}><Link to="/eventos" className="sub-menu-item">Eventos</Link></li>
                            <li className={manu === '/sucursales/puerto-interior' ? 'active' : ''}><Link to="/sucursales/puerto-interior" className="sub-menu-item">Puerto Interior</Link></li>
                            {localuser.length > 0 ? (
                                <li className={`has-submenu parent-menu-item ${['/dashboard', '/perfil'].includes(manu) ? 'active' : ''}`}>
                                    <Link to="#" className="sub-menu-item" onClick={() => toggleSubmenu('arandaplus')}>Mi cuenta Aranda+</Link> <span className="menu-arrow"></span>
                                    <ul id="submenu-arandaplus" className={`submenu ${submenuOpen.arandaplus ? 'open' : ''}`}>
                                        <li className={manu === '/dashboard' ? 'active' : ''}><Link to="/dashboard" className="sub-menu-item">Resumen</Link></li>
                                        <li className={manu === '/perfil' ? 'active' : ''}><Link to="/perfil" className="sub-menu-item">Mi perfil</Link></li>
                                        <li className={manu === '/pedidos' ? 'active' : ''}><Link to="/pedidos" className="sub-menu-item">Mis pedidos</Link></li>
                                        <li className={manu === '/logout' ? 'active' : ''}><Link to="/logout" className="sub-menu-item">Cerrar sesión</Link></li>
                                    </ul>
                                </li>
                            ) : (
                                <li className={`has-submenu parent-menu-item ${['/programa-beneficios', '/login'].includes(manu) ? 'active' : ''}`}>
                                    <Link to="#" className="sub-menu-item" onClick={() => toggleSubmenu('arandaplus')}>Beneficios Aranda+</Link> <span className="menu-arrow"></span>
                                    <ul id="submenu-arandaplus" className={`submenu ${submenuOpen.arandaplus ? 'open' : ''}`}>
                                        <li className={manu === '/programa-beneficios' ? 'active' : ''}><Link to="/programa-beneficios" className="sub-menu-item">Registro</Link></li>
                                        <li className={manu === '/login' ? 'active' : ''}><Link to="/login" className="sub-menu-item">Iniciar sesión</Link></li>
                                    </ul>
                                </li>
                            )}
                            <li className={`has-submenu parent-menu-item ${['/servicios', '/servicio2', '/servicios3'].includes(manu) ? 'active' : ''}`}>
                                <Link to="#" className="sub-menu-item" onClick={() => toggleSubmenu('mas')}>Más</Link> <span className="menu-arrow"></span>
                                <ul id="submenu-mas" className={`submenu ${submenuOpen.mas ? 'open' : ''}`}>
                                    <li className={manu === '/blog' ? 'active' : ''}><Link to="/blog" className="sub-menu-item">Blog</Link></li>
                                    <li className={manu === '/contacto' ? 'active' : ''}><Link to="/contacto" className="sub-menu-item">Contacto</Link></li>
                                    <li className={manu === '/facturacion' ? 'active' : ''}><Link to="/facturacion" className="sub-menu-item">Facturación</Link></li>
                                    <li className={manu === '/proveedores' ? 'active' : ''}><Link to="http://201.151.252.243:70/controlprovx/" target='_blank' className="sub-menu-item">Proveedores</Link></li>
                                    <li className={manu === '/alianzas' ? 'active' : ''}><Link to="/alianzas" className="sub-menu-item">Alianzas</Link></li>
                                    <li className={manu === '/aviso-privacidad' ? 'active' : ''}><Link to="/aviso-privacidad" className="sub-menu-item">Aviso de Privacidad</Link></li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
            </header>

            <Offcanvas show={open} onHide={() => setOpen(!open)} placement='end'>
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>
                        <h5 id="offcanvasRightLabel" className="mb-0">
                            <img src={logoDark} className="light-version" alt="" />
                            <img src={logoLight} className="dark-version" alt="" />
                        </h5>
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body >
                    <div className="row">
                        <div className="col-12">
                            <img src={contact} className="img-fluid" alt="" />
                            <form>
                                <div className="my-3 text-center">
                                    <h6 className="text-uppercase mb-0 fw-semibold">Sign In</h6>
                                </div>

                                <div className="mb-3">
                                    <label className="form-label fw-semibold">Your Email</label>
                                    <input name="email" id="email" type="email" className="form-control" placeholder="example@website.com" />
                                </div>

                                <div className="mb-3">
                                    <label className="form-label fw-semibold" htmlFor="loginpass">Password</label>
                                    <input type="password" className="form-control" id="loginpass" placeholder="Password" />
                                </div>

                                <div className="d-flex justify-content-between">
                                    <div className="mb-3">
                                        <div className="form-check">
                                            <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                            <label className="form-label form-check-label text-muted" htmlFor="flexCheckDefault">Remember me</label>
                                        </div>
                                    </div>
                                    <span className="forgot-pass text-muted small mb-0"><Link to="/reset-password" className="text-muted">Forgot password ?</Link></span>
                                </div>

                                <button className="btn btn-primary w-100" type="submit">Sign in</button>

                                <div className="col-12 text-center mt-3">
                                    <span><span className="text-muted me-2 small">Don't have an account ?</span> <Link to="/signup" className="text-dark fw-semibold small">Sign Up</Link></span>
                                </div>
                            </form>
                        </div>
                    </div>

                    <div className="offcanvas-footer p-4 border-top text-center">
                        <ul className="list-unstyled social-icon mb-0">
                            {footerSocial.map((item, index) => {
                                let Icon = item.icon
                                return (
                                    <li className="list-inline-item m-x-2" key={index}><Link to={item.link} target="_blank" className="rounded"><Icon className="fea icon-sm align-middle" title="dribbble"></Icon></Link></li>
                                )
                            })}
                        </ul>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>

        </>
    )
}
